module.exports = __webpack_public_path__ + "fonts/806854d.ttf";